import React, { FC } from "react";
import { useSelector } from "react-redux";
import { Col, Container, Row } from "reactstrap";
import CollapsibleCard from "src/components/CollapsibleCard/CollapsibleCard";
import RadioButton from "src/components/Form/RadioButtonV2/RadioButton";
import { IconName } from "src/components/Icon/Icon";
import { IRootState } from "src/store/reducers";
import * as S from "../../../constants/StringConstants";
import "./BrokerAnalyzerWidget.scss";

const BrokerAnalyzerWidget: FC = () => {
  const { preferences } = useSelector((state: IRootState) => state.brokerAnalyzerPreferences);

  return (
    <CollapsibleCard
      title={S.PD_BROKER_ANALYZER_PREFERENCES}
      iconName={IconName.BrokerBuilderAnalyzer}
      defaultOpen={false}>
      <Container className="analyzer-widget-container">
        {preferences.length > 0 &&
          preferences.map(option => (
            <Row key={option.value}>
              <Col>
                <RadioButton name="preferenceID" label={option.key} value={option.value} />
              </Col>
            </Row>
          ))}
      </Container>
    </CollapsibleCard>
  );
};

export default BrokerAnalyzerWidget;
